export default __webpack_public_path__ + "static/media/flag-svalbard-and-jan-mayen.ac315a4c.svg";